import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Header, Modal, Checkbox, Icon } from 'semantic-ui-react';
import { intToNote } from '../../util/notes';

export const RangeEntry = ({ ranges, vtMap, submit, label }) => {
    const [ modalOpen, setModalOpen ] = useState(false);
    const [ newState, setNewState ] = useState([]);
    const [ ossiaStates, setOssiaStates ] = useState([]);

    const reset = () => {
        setNewState(JSON.parse(JSON.stringify(ranges)));

        setOssiaStates(ranges.map(r => {
            return r.ossia_high && r.ossia_low && r.ossia_high !== r.high && r.ossia_low !== r.low;
        }));
    };

    useEffect(reset, [ranges]);

    const vtOptions = Object.keys(vtMap).map((k) => {
        return { text: vtMap[k].name, value: k, key: k};
    });

    const noteOptions = [...Array(88).keys()].map(note => {
        return { text: intToNote(note), value: note, key: note };
    });

    const stateDisplay = newState.map((r, i) => {

        const handleRemove = () => {
            const editedState = JSON.parse(JSON.stringify(newState));
            editedState.splice(i, 1);
            setNewState(editedState);

            const editedOssiaStates = JSON.parse(JSON.stringify(ossiaStates));
            editedOssiaStates.splice(i, 1);
            setOssiaStates(editedOssiaStates);
        }

        const removeButton = (
            <Button onClick={handleRemove}>Remove</Button>
        );

        const handleSelectVT = (e, {value}) => {
            const editedState = JSON.parse(JSON.stringify(newState));
            editedState[i].voice_type = `#${value}#`;
            setNewState(editedState);
        };

        const handleSelectNote = (discriminator) => {
            return (e, {value}) => {
                const editedState = JSON.parse(JSON.stringify(newState));
            editedState[i][discriminator] = value;
            setNewState(editedState);
            }
        }
        
        const vtDrop = <Dropdown
            options={vtOptions}
            onChange={handleSelectVT}
            search
            selection
            value={r.voice_type.slice(1,-1)}
        />;

        const lowDrop = <Dropdown
            options={noteOptions}
            onChange={handleSelectNote("low")}
            selection
            value={r.low}
        />;

        const highDrop = <Dropdown
            options={noteOptions}
            onChange={handleSelectNote("high")}
            selection
            value={r.high}
        />;

        const lowOssDrop = <Dropdown
            options={noteOptions}
            onChange={handleSelectNote("ossia_low")}
            selection
            value={r.ossia_low}
        />;

        const highOssDrop = <Dropdown
            options={noteOptions}
            onChange={handleSelectNote("ossia_high")}
            selection
            value={r.ossia_high}
        />;

        const handleCheck = (e, {checked}) => {
            const editedOssiaStates = JSON.parse(JSON.stringify(ossiaStates));
            editedOssiaStates[i] = !!checked;
            setOssiaStates(editedOssiaStates);
        }

        const ossiaCheck = <Checkbox
            defaultChecked={ossiaStates[i]}
            onChange={handleCheck}
            label='Ossia Notes?'
        />

        const ossiaDisplay = ossiaStates[i] ? ( <div>
            <div>{ossiaCheck}</div><div> Ossia low note: {lowOssDrop} Ossia high note: {highOssDrop}</div>
        </div> ) : ( <div> {ossiaCheck} </div> );

        return (
            <div key={i} className="edit-range-row">
                <Header>Range {i+1} {removeButton}</Header>
                <div>Voice Type: {vtDrop}</div>
                <div>Low note: {lowDrop} High note: {highDrop}</div>
                {ossiaDisplay}
            </div>
        );
    });

    const handleAdd = () => {
        const editedState = JSON.parse(JSON.stringify(newState));
        editedState.push({
            high: 48,
            low: 48,
            ossia_high: 48,
            ossia_low: 48,
            voice_type: '#17#',
            id: 0
        });
        setNewState(editedState);

        const editedOssiaStates = JSON.parse(JSON.stringify(ossiaStates));
        editedOssiaStates.push(false);
        setOssiaStates(editedOssiaStates);
    };

    const newButton = (
        <Button basic icon labelPosition='left' onClick={handleAdd}>
            <Icon name='add'/>
            Add Range
        </Button>
    );

    return (
        <Modal
            trigger={<Button fluid>{label}</Button>}
            className="rule-entry-modal"
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            onOpen={() => setModalOpen(true)}
        >
            <Modal.Header>
                <Header as='h3' className='subtitle' color={"purple"}>{label}</Header>
            </Modal.Header>
            <Modal.Content scrolling>
                {stateDisplay}
                {newButton}
            </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={() => {
                    reset(); setModalOpen(false);
                }}>Discard changes</Button>
                <Button color='green' onClick={() => {
                    setModalOpen(false); submit(JSON.parse(JSON.stringify(newState)))
                }}>Done</Button>
            </Modal.Actions>
        </Modal>
    )
}